import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist, deleteWishlistItem } from "../../redux/actions/wishlistAction";
import { Heart } from "lucide-react";
import { toast } from "react-toastify";

const WishlistButton = ({ productId }) => {
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state) => state.wishlist.items);

  // Check if product is in wishlist
  const isInReduxWishlist = wishlistItems.some(item => item.product?.id === productId);

  // Local state for instant toggle & persistent color
  const [isWishlisted, setIsWishlisted] = useState(false);

  // Sync local state with redux on mount and when wishlist updates
  useEffect(() => {
    setIsWishlisted(isInReduxWishlist);
  }, [isInReduxWishlist]);

  const handleToggle = async () => {
    if (isWishlisted) {
      // Find wishlist item to delete
      const existingItem = wishlistItems.find(item => item.product?.id === productId);
      if (!existingItem) return;

      // Optimistically update UI
      setIsWishlisted(false);

      try {
        await dispatch(deleteWishlistItem(existingItem.id));
        toast.info("Removed from wishlist");
      } catch (err) {
        // Revert UI if failure
        setIsWishlisted(true);
        toast.error("Failed to remove from wishlist");
      }
    } else {
      // Optimistically update UI
      setIsWishlisted(true);

      try {
        await dispatch(addToWishlist({ product: productId }));
        toast.success("Added to wishlist");
      } catch (err) {
        // Revert UI if failure
        setIsWishlisted(false);
        toast.error("Failed to add to wishlist");
      }
    }
  };

  return (
    <button onClick={handleToggle} aria-label="Toggle wishlist">
      <Heart
        className={`w-6 h-6 transition-all duration-300 ease-in-out cursor-pointer ${
          isWishlisted ? "fill-red-500 text-red-500" : "text-gray-400"
        }`}
      />
    </button>
  );
};

export default WishlistButton;
